app.service('outletManager', function(productSalesTabs, pageConfig, console) {
	var hash, productId, outletCategories;

	function getHuCode(position = 2) {
		const regexp = /(outlet-[a-z]+)\|hu-([0-9a-z]+)/g;
		var result = regexp.exec(hash);
		return result ? result[position] : false;
	}

	function getLinkName() {
		const regexp = /^#(outlet-[a-z]+)/g;
		if (getHuCode(1)) {
			return getHuCode(1);
		}
		var result = regexp.exec(hash);
		return result ? result[1] : false;
	}

	function getTarget() {
		const regexp = /(outlet-[a-z]+)\|([a-z]+)/g;
		var result = regexp.exec(hash);
		return result ? result[2] : false;
	}

	function checkHash(h) {
		hash = h;
		productId = pageConfig.getData('productCard').id;
		outletCategories = pageConfig.getData('productCard').outletCategories;
		const linkName = getLinkName();
		const huCode = getHuCode();
		const target = getTarget();
		//alert(linkName + huCode + target);

		if (hash === '#outlet') {
			productSalesTabs.setOutletCategory({
				outletCategoryId: outletCategories[0].outletCategoryId,
				productId: productId,
				scroll: "tab",
				tab : "outlet"
			});
			return;
		} else if (hash === '#outlet-offer') {
			productSalesTabs.setOutletCategory({
				outletCategoryId: outletCategories[0].outletCategoryId,
				productId: productId,
				scroll: "top"
			});
			return;
		} else if (hash.indexOf('#afterSearch-outlet') === 0) {
			productSalesTabs.setOutletCategory({
				outletCategoryId: outletCategories[0].outletCategoryId,
				productId: productId,
				scroll: "none"
			});
			return;
		} else if (linkName) {
			var outletCategory = outletCategories.filter(function(n) {
				return n.linkName === linkName
			});

			if (outletCategory.length) {
				var data = {
					outletCategoryId: outletCategory[0].outletCategoryId,
					productId: productId,
					scroll: "tab",
					tab: "outlet"
				}
				if (huCode) {
					data.huCode = huCode;
					data.scroll = "hu";
				} else if (target) {
					data.tab = target;
				}
				productSalesTabs.setOutletCategory(data);
				return;
			}
		}
		console.log('inny przypadek outletu');
	}

	return {
		checkHash
	};
});
